/* global $, Modernizr */

const $search = $('.js-search');
const $searchToggler = $('.js-search-toggler');
const $searchDropdown = $('.js-search-dropdown');
const SEARCH_INPUT_SELECTOR = '.js-search-input';

const BREAKPOINT = 992;
const SEARCH_FOCUS_DELAY = 300;

function getIcon(name) {
  return `
    <svg class="icon icon-${name}" aria-hidden="true">
      <use xlink:href="#icon-${name}"></use>
    </svg>
  `;
}

const search = {
  initialize() {
    if ($search.length) {
      this.createEvents();
    }
  },

  createEvents() {
    if (Modernizr.mq(`(min-width: ${BREAKPOINT}px)`)) {
      $searchToggler.on('click', () => {
        const isOpen = $searchDropdown.hasClass('is-open');
        const $input = $searchDropdown.find(SEARCH_INPUT_SELECTOR);

        this.toggleSearch($input, isOpen);
      });
    }
  },

  toggleSearch(input, isOpen) {
    if (!isOpen) {
      setTimeout(
        () => {
          if (input) {
            input.focus();
          }
        },
        SEARCH_FOCUS_DELAY,
      );
    }

    if (isOpen) {
      $searchToggler.html(getIcon('search'));
    } else {
      $searchToggler.html(getIcon('close'));
    }

    $searchDropdown.toggleClass('is-open');
  },
};

export default search;
